import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"

const copy = {
  en: {
    hk_question: "Are you from Hong Kong and thinking about moving to Canada?",
    hk_intro:
      "Here’s a step-by-step guide to help you prepare before your journey.",
    canada_guide_title: "Canada Guide",
    canada_guide_body:
      "As you get ready to come to Canada, visit our Canada Guide page to learn about finance, education, employment, and more. It offers practical information about everyday life in Canada.",
    need_help_title: "Need More Help?",
    need_help_body:
      "If you have questions about life in Canada, many friendly volunteers from different churches are ready to support you. Join our newcomer community to ask questions, find answers, and share experiences together.",
    connect_local_title: "Connect with Locals",
    connect_local_body:
      "Moving to a new country can feel overwhelming, with so much to learn at once. You don’t have to do it alone - we’re here to walk with you and provide support as you settle into life in Canada.",
  },
  cn: {
    hk_question: "你來自香港，並有興趣來到加拿大嗎？",
    hk_intro: "這裡有一份步驟指南，幫助你在出發前做好準備。",
    canada_guide_title: "加拿大指南",
    canada_guide_body:
      "為來加做好準備。前往我們的指南頁面，查找財務、教育、就業等主題的協助，提供在加拿大生活的一般資訊。",
    need_help_title: "需要更多幫助?",
    need_help_body:
      "若對來加流程有疑問，我們有來自不同教會的義工樂意協助並回答你的問題。加入新移民社群，一起學習與分享。",
    connect_local_title: "本地聯絡",
    connect_local_body:
      "移居到新國家並不容易，尤其需要學習許多新事物。我們在這裡陪伴你移居加拿大並提供協助。",
  },
}

const Home = ({ lang = "en" }) => {
  const t = key => copy[lang][key]
  const isChinese = lang === "cn"

  return (
    <Layout lang={lang}>
      <section className="index__section">
        <div className="index__item o__reverse o__blue">
          <div className="index__item-content">
            <h2>{t("hk_question")}</h2>
            <p>{t("hk_intro")}</p>
          </div>
          <Link
            className="index__media o__hongkong"
            to={isChinese ? "/cn/step/" : "/step/"}
          />
        </div>

        <div className="index__divider" />

        <div className="index__item">
          <Link
            className="index__media o__canada"
            to={isChinese ? "/cn/guide/" : "/guide/"}
          />
          <div className="index__item-content o__yellow">
            <h2>{t("canada_guide_title")}</h2>
            <p>{t("canada_guide_body")}</p>
          </div>
        </div>

        <div className="index__divider" />

        <div className="index__item o__reverse">
          <div className="index__item-content o__pink">
            <h2>{t("need_help_title")}</h2>
            <p>{t("need_help_body")}</p>
          </div>
          <Link
            className="index__media o__people"
            to={isChinese ? "/cn/network/" : "/network/"}
          />
        </div>

        <div className="index__divider" />

        <div className="index__item">
          <Link
            className="index__media o__group"
            to={isChinese ? "/cn/local/" : "/local/"}
          />
          <div className="index__item-content o__green">
            <h2>{t("connect_local_title")}</h2>
            <p>{t("connect_local_body")}</p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Home
